export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN as string;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID as string;
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE as string;
export const DASHBOARD_BASE_URL = import.meta.env.VITE_DASHBOARD_URL as string;
